import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ad-page" }
const _hoisted_2 = { class: "ad-page__content" }

import Advertising from '@/components/Advertising.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_HpsfirProPageHeader = _resolveComponent("HpsfirProPageHeader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HpsfirProPageHeader, {
      title: "首页顶部",
      "title-en": "HOME TOP",
      description: "配置首页顶部广告位，支持轮播或多广告均匀展示。"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Advertising, { position: "hometop" })
    ])
  ]))
}
}

})